import React from "react";
import './Logo.css';

function Logo() {
    return(
        <img id='logo' src={require('./qtlogowip.webp')} alt=""/>
    )
}

export default Logo;
